const getNewProductLabel = (hasFewerInclusions?: boolean): string =>
  hasFewerInclusions ? `Fewer inclusions, but check out this new product` : `New product`;

export default getNewProductLabel;
